import FloorplanInfoModal from "./FloorplanInfoModal";

export default FloorplanInfoModal;
